module.exports = __webpack_public_path__ + "media/images/countrysquared/zm-2512500e3fd391c76b65cad4aafd4b73.svg";